import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { DefaultButton, Dropdown, Panel, PrimaryButton, SpinButton, Stack, TextField } from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import { dbDate } from "../../Utilities/dbDate";
import DatePickerPL from "../../Components/DatePickerPL";
import NetGrossPicker from "../../Components/NetGrossPicker";


function AddVentureAgreement(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState("");
    const [agreementNumber, setAgreementNumber] = useState("");
    const [representative, setRepresentative] = useState("");
    const [date, setDate] = useState(new Date());
    const [paymentDeadline, setPaymentDeadline] = useState(14);
    const [net, setNet] = useState(0);
    const [vat, setVat] = useState(0);
    const [gross, setGross] = useState(0);
    const [agreementCategory, setAgreementCategory] = useState(null);
    const [agreementCategories, setAgreementCategories] = useState([]);
    const [contractor, setContractor] = useState(null);
    const [contractors, setContractors] = useState([]);

    const _submit = (e) => {
        e.preventDefault();
        const data = {
            name: name,
            agreement_number: agreementNumber,
            representative: representative,
            date: dbDate(date),
            payment_deadline: paymentDeadline,
            net_value: net,
            vat: vat,
            gross_value: gross,
            venture_id: props.add.venture_id,
            agreement_category_id: agreementCategory.key,
            contractor_id: contractor.key,
        };
        fetch(`/api/venture/${props.add}/agreement`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Authorization": "Bearer " + user.token,
            },
        }).then(res => res.json())
            .then(json => {
                props.onSuccess(json);
                props.dismissPanel();
            })
            .catch(err => {
                console.log(err);
            });
    };

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign="space-between">
        <PrimaryButton type="submit" form="AddVentureAgreement">Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        setName("");
        setNet(0);
        setGross(0);
        setAgreementCategory(null);
        setContractor(null);
        if (props.add) {
            async function fetchCategories() {
                await fetch(`/api/agreement_category`, {
                    method: "GET",
                    signal: abortController.signal,
                    headers: {
                        "Authorization": "Bearer " + user.token,
                    },
                }).then(res => res.json())
                    .then(data => {
                        setAgreementCategories(data.map((item) => {
                            return { key: item.id, text: `${item.type} - ${item.name}` };
                        }));
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
            async function fetchContractors() {
                await fetch(`/api/contractor`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setContractors(data.map((item) => {
                            return {key: item.id, text: item.name};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchContractors();
            fetchCategories();
        }
        return () => abortController.abort();
    }, [props.add])



    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Koszt"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id="AddVentureAgreement">
                <TextField required autoFocus label="Nazwa" value={name}
                           onChange={(e) => setName(e.target.value || "")} />
                <Dropdown
                    label="Kategoria"
                    selectedKey={agreementCategory ? agreementCategory.key : undefined}
                    onChange={(e, item) => setAgreementCategory(item)}
                    placeholder="Wybierz z listy"
                    options={agreementCategories}
                    required
                />
                <Dropdown
                    label="Wykonawca"
                    selectedKey={contractor ? contractor.key : undefined}
                    onChange={(e, item) => setContractor(item)}
                    placeholder="Wybierz z listy"
                    options={contractors}
                    required
                />
                <TextField required autoFocus label="Reprezentowany przez" value={representative}
                           onChange={(e) => setRepresentative(e.target.value || "")} />
                <TextField required autoFocus label="Numer Umowy" value={agreementNumber}
                           onChange={(e) => setAgreementNumber(e.target.value || "")} />
                <DatePickerPL
                    label="Data"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={date}
                    onSelectDate={(e) => setDate(e || '')}
                />
                <NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} />
                <SpinButton
                    label={"Termin Płatności"}
                    labelPosition={"top"}
                    step={1}
                    min={0}
                    max={100}
                    incrementButtonAriaLabel={"+1"}
                    decrementButtonAriaLabel={"-1"}
                    value={paymentDeadline}
                    onChange={(e) => setPaymentDeadline(e.target.value || "")}
                />

            </form>
        </Panel>
    );
}

export default AddVentureAgreement;